import React from 'react';
import { Eye } from 'lucide-react';

const ClientsTable = ({ 
  currentClients,
  searchTerm,
  handleViewClick,
  updateClientStatusLoading,
  selectedStatus,
  handleStatusChange,
  getStatusBadgeColor,
  formatClientStatus
}) => {
  return (
    <div className="bg-white rounded-lg shadow overflow-hidden h-full flex flex-col">
      <div className="flex-1 min-h-0 overflow-auto">
        <table className="min-w-full">
          <thead className="bg-gray-50 sticky top-0 z-10">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Client ID</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Client Name</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Contact Person</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Contact No</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">City</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Action</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-200">
            {currentClients.length > 0 ? (
              currentClients.map((client, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm font-medium">{client.client_id}</td>
                  <td className="px-6 py-4 text-sm">{client.client_name}</td>
                  <td className="px-6 py-4 text-sm">{client.contact_person}</td>
                  <td className="px-6 py-4 text-sm">{client.contact_phone}</td>
                  <td className="px-6 py-4 text-sm">{client.city}</td>
                  <td className="px-6 py-4">
                    <select
                      value={selectedStatus[client.client_id] || formatClientStatus(client.status)}
                      onChange={(e) => handleStatusChange(client.client_id, e.target.value)}
                      disabled={updateClientStatusLoading}
                      className={`px-3 py-1 text-xs font-semibold rounded border ${getStatusBadgeColor(selectedStatus[client.client_id] || client.status)}`}
                    >
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </td>
                  <td className="px-6 py-4">
                    <button
                      onClick={() => handleViewClick(client)}
                      className="text-blue-600 hover:text-blue-900 flex items-center space-x-1 bg-blue-50 px-3 py-1 rounded"
                    >
                      <Eye size={16} />
                      <span>View</span>
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="px-6 py-8 text-center text-gray-500">
                  {searchTerm ? 'No clients match your search' : 'No clients found'}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ClientsTable;